

<div class="dtf-carousel" >
  <!--Announcement Banner Code-->
  <div class="dtf-alertpage"></div>


 <!--Carousel -->
<!--Static call-->
<ngb-carousel [animation]="false" [interval]="myInterval"  [keyboard]="false" [showIndicators]="false" [noPause]="false" [wrap]="true" [showNavigationArrows]="false" *ngIf="displayStatic">
  <ng-template ngbSlide>
    <section class="mbfs-home-hero"  style="background-image: url({{this.divStyle}});">
      <section class="mbfs-home-hero__header" [ngClass]="{'mbfs-home-hero__header__mid': position2 === 'mid'}">
        <h2 class="mbfs-home-hero__header-subtitle">
          {{ 'HomePage.BannerHeader' | translate }}
        </h2>
      </section>
    </section>
  </ng-template>
</ngb-carousel>
 <!--Backend call-->
    <ngb-carousel [animation]="false" [interval]="myInterval"  [keyboard]="false" [showIndicators]="false" [noPause]="false" [wrap]="true" [showNavigationArrows]="false" *ngIf="!displayStatic">
    <ng-template ngbSlide  *ngFor="let slider of sliders">
      <section class="mbfs-home-hero"  style="background-image: url({{slider.bannerImgUrl}});">
        <section class="mbfs-home-hero__header" [ngClass]="{'mbfs-home-hero__header__top': slider.bannerTxtPosition === 'top', 'mbfs-home-hero__header__mid': slider.bannerTxtPosition === 'mid', 'mbfs-home-hero__header__bot': slider.bannerTxtPosition === 'bot'}">
          <h2 class="mbfs-home-hero__header-subtitle">
            {{ slider.bannerHeader }}
          </h2>
          <div attr.aria-label= "{{slider.bannerCopy}}">
          <p class="mbfs-home-hero__header-text" role= "heading" *ngIf="!isBlank(slider.bannerCopy)">
            {{slider.bannerCopy}}
          </p>
          </div>
          <div class="centerimage" *ngIf="!isBlank(slider.bannerExtra) && slider.bannerExtra=='S'" >
            <div class="mbfs-home-hero-smallca">
            <section class="mbfs-home-hero-smallca" *ngIf="!isBlank(slider.bannerEnableInsert)"
              style="background-image: url({{slider.bannerInsertImgUrl}});">
            </section>
          </div>
        </div>
        <div  *ngIf="!isBlank(slider.bannerExtra) && slider.bannerExtra=='M'" >
          <br>
          <div class="mbfs-home-hero-mediumca">
          <section class="mbfs-home-hero-mediumca" *ngIf="!isBlank(slider.bannerEnableInsert)"
            style="background-image: url({{slider.bannerInsertImgUrl}});">
          </section>
        </div>
        <br>
      </div>
      <div *ngIf="isBlank(slider.bannerExtra2)">   
        <a *ngIf="!isBlank(slider.btnLabel) && slider.bannerExtra !=='L'" target="_blank" class="mbfs-button"
          href="{{slider.btnUrl}}">{{ slider.btnLabel }}</a>
        <a *ngIf="!isBlank(slider.btnLabel) && slider.bannerExtra=='L'" class="mbfs-button"
          href="{{slider.btnUrl}}">{{ slider.btnLabel }}</a>
      </div>
      <div *ngIf="!isBlank(slider.bannerExtra2)">
        <a *ngIf="!isBlank(slider.btnLabel)" class="mbfs-button"
          (click)="clickvideo(slider.btnUrl)" href="javascript:void(0);">{{ slider.btnLabel }}</a>
      </div>
       </section>
      </section>
    </ng-template>
  </ngb-carousel>

  <!-- <section class="mbfs-home-hero">
    <section class="mbfs-home-hero__header">
      <h2 class="mbfs-home-hero__header-subtitle">
        {{ 'HomePage.BannerHeader' | translate }}
      </h2>
      <p class="mbfs-home-hero__header-text" *ngIf="this.dbCopy ==='dbon'">
        {{alertsCopy.btnLink}}
      </p>
      <p class="mbfs-home-hero__header-text" *ngIf="this.dbCopy ==='dboff'">
        {{ 'HomePage.Bannerp1' | translate }}
      </p> -->
      <!-- <div class="listbox">
        <p class="mbfs-home-hero__header-text-demi">
          {{ 'HomePage.Bannerp1' | translate }}
        </p>
       </div> -->
      <!-- Commenting bullets <ul class = "listbox">
        <li class="mbfs-home-hero__header-text-demi"> {{ 'HomePage.Bannertext2' | translate }}</li>
        <li class="mbfs-home-hero__header-text-demi"> {{ 'HomePage.Bannertext3' | translate }}</li>
      </ul> -->
    <!-- </section>
  </section> -->
  <div class ="onlinebackground">
  <section class="mercedes-me-login">
    <div class="mercedes-me-login__column">
      <h2 class="mercedes-me-login__column-headline">{{ 'HomePage.OnlineAcctHeader' | translate }}</h2>
      <ul class="mercedes-me-login__column-app-promotion-ul">
        <li class="mercedes-me-login__column-app-promotion-info">{{ 'HomePage.Onlinetext1' | translate }}</li>
        <li class="mercedes-me-login__column-app-promotion-info">{{ 'HomePage.Onlinetext2' | translate }}</li>
        <li class="mercedes-me-login__column-app-promotion-info">{{ 'HomePage.Onlinetext3' | translate }}</li>
        <li class="mercedes-me-login__column-app-promotion-info">{{ 'HomePage.Onlinetext4' | translate }}</li>
        <li class="mercedes-me-login__column-app-promotion-info">{{ 'HomePage.Onlinetext5' | translate }}</li>
        <li class="mercedes-me-login__column-app-promotion-info">{{ 'HomePage.Onlinetext6' | translate }}</li>
        <li class="mercedes-me-login__column-app-promotion-info">{{ 'HomePage.Onlinetext7' | translate }}</li>
        <li class="mercedes-me-login__column-app-promotion-info">{{ 'HomePage.Onlinetext8' | translate }}</li>
        <li class="mercedes-me-login__column-app-promotion-info">{{ 'HomePage.Onlinetext9' | translate }}</li>


      </ul>
    </div>
  </section>
  </div>
  <section class="mbfs-home-insurance">
    <div class="mbfs-home-insurance__content">
    </div>
  </section>
</div>


<div *ngIf = "passwordResetFlag">
  <div class="dtf-passwordresetconfirmpage"></div>
</div> 

<div *ngIf = "RegistrationPopup">
  <div class="dtf-registrationPopuppage"></div>
</div> 

<div *ngIf = "RegistrationConfirmFlag">
  <div class="dtf-registrationConfirm"></div>
</div> 

